import { useNamespace, useOkapiKy } from '@folio/stripes/core';
import { groupBy } from 'lodash';
import { useQuery } from 'react-query';

function useDefaultFields(defaultFieldId) {
  const okapiKy = useOkapiKy();
  const [namespace] = useNamespace({ key: 'defaultFields' });

  const {
    isLoading,
    isError,
    data = {},
    refetch,
    ...rest
  } = useQuery(
    [namespace, defaultFieldId],
    () => okapiKy
      .get(
        defaultFieldId
          ? `inventory-defaultFields/${defaultFieldId}`
          : 'inventory-defaultFields?limit=2147483647',
      )
      .json(),
    { enabled: defaultFieldId ? Boolean(defaultFieldId) : true },
  );

  return {
    isLoading,
    isError,
    defaultFields: defaultFieldId ? data : data.defaultFields,
    groupedFields: groupBy(data?.defaultFields, 'entityType'),
    refetch,
    rest,
  };
}

export default useDefaultFields;
